<template>
    <div class="row">
        <div class="col-lg-2 col-md-2 attribute-placeholder" v-for="attribute in attributes">
            <label>
                <span>{{ attribute.name }}</span>
                <span class="attribute-number-value" v-if="attribute.type === 2 && !attribute.ui_type && attribute.value">
                    :&nbsp;&nbsp;&nbsp;({{ attribute.value[0] }} - {{ attribute.value[1] }})
                </span>
            </label>
            <multiselect v-if="attribute.type === 1"
                 :placeholder="t('Attributes')"
                 :options="attribute.values"
                 v-model="attribute.value"
                 :group-select="false"
                 label="value"
                 :maxHeight="300"
                 :custom-label="labelOption"
                 @input="onChangeText(attribute)"
            >
                <div slot="noOptions">{{ t('List is empty') }}</div>
            </multiselect>
            <multiselect v-if="attribute.type === 2 && attribute.ui_type === 4"
                 :placeholder="t('Attributes')"
                 :options="attribute.options"
                 v-model="attribute.value"
                 :group-select="false"
                 :track-by="'name'"
                 label="name"
                 :maxHeight="300"
                 :custom-label="labelOption"
                 @input="onChangeText(attribute)"
            >
                <div slot="noOptions">{{ t('List is empty') }}</div>
            </multiselect>
            <!--                </div>-->
            <div v-if="attribute.type === 2 && !attribute.ui_type" class="form-inline form-group controls">
                <input type="number" :min="attribute.range[0]" v-model="attribute.value[0]" @change="onChangeNumeric(attribute)" class="controls form-control price-range-input">
                <input type="number" :max="attribute.range[1]" v-model="attribute.value[1]" @change="onChangeNumeric(attribute)" class="controls form-control price-range-input">
            </div>
            <div v-if="attribute.type === 3">
                <toggle-button v-if="attribute.type === 3"
                   @change="onChangeBoolean(attribute)"
                   v-model="attribute.value"
                   :height="25"
                   :width="70"
                   :labels="getValueForBoolean(attribute)"
                   :sync="attribute.sync"
                />
            </div>
        </div>
    </div>
</template>

<script>

    import Multiselect from '../components/Multiselect';
    import VueSlider from 'vue-slider-component';

    export default
    {
        props: {
            attributes: {
                Type: Array,
                Default: []
            },
            onSelectAttributes: {
                Type: Function,
                Default: () => {}
            },
            attributesSelected: {
                Type: Array,
                Default: [],
            }
        },
        components: {VueSlider, Multiselect},
        data() {
            return {

            };
        },
        mounted() {

        },
        methods: {
            onChangeNumeric: function(attribute) {
                this.selectAttributes(attribute);
            },
            onChangeText: function(attribute) {
                this.selectAttributes(attribute);
            },
            onChangeBoolean: function(attribute) {
                this.selectAttributes(attribute);
            },
            selectAttributes: function (attribute) {
                let index = this.attributesSelected.findIndex((attr) => {
                    return attr.id === attribute.id;
                });
                if (index === -1) {
                    this.attributesSelected.push(attribute);
                } else if (attribute.value.length === 0) {
                    this.attributesSelected.splice(index, 1);
                }
                this.onSelectAttributes();
            },
            getValueForBoolean: function(attribute) {
                let res = {};
                attribute.values.forEach((value) => {
                    if (value.id === attribute.checked) {
                        res['checked'] = value.value;
                    }
                    if (value.id === attribute.unchecked) {
                        res['unchecked'] = value.value;
                    }
                });

                return res;
            },
            labelOption(option) {
                if (option.name) {
                    return `${option.name}`;
                }
                return `${option.value}`;
            }
        }
    }
</script>

<style lang="sass">
    @import "../../node_modules/vue-slider-component/theme/default.css";
    @import "src/assets/scss/variable.scss";

    .attribute-number-value {
        color: $main-background-color;
    }
    .slider-placeholder {
        margin: 3px 0 3px 15px;
    }
    .no-border {
        border: none!important;
        box-shadow: none!important;
    }
    .attribute-placeholder {
        min-height: 100px;
    }
</style>


// WEBPACK FOOTER //
// ProductAttribute.vue?2e6f0212